import BetModel from '../../../vendor_core/core/src/model/BetModel';
import BuyFeatureModel from '../../../vendor_core/core/src/model/BuyFeatureModel';
import SpinModel from '../../../vendor_core/core/src/model/SpinModel';
import UIController from '../../../vendor_core/core/src/ui/UIController';
import { UIUpdateEvent } from '../../../vendor_core/core/src/ui/UIUpdateEvents';
import VendorSpinStartMSTState from "../../../vendor_core/src/states/minSpinTimeStates/VendorSpinStartMSTState";
import Layer from '../../../vendor_core/core/src/utils/Layer';
import { DefaultLayers } from '../../../vendor_core/core/src/utils/Layers';
import ViewManager from '../../../vendor_core/core/src/utils/ViewManager';
import PercentScalableSceneView from '../../../vendor_core/core/src/views/PercentScalableSceneView';
import ReelGroup from '../../../vendor_core/core/src/views/ReelGroup';
import Button from '../../../vendor_core/core/src/views/components/Button';
import DoubleChanceModel from "../../model/DoubleChanceModel";
import ConfigManager from '../../../vendor_core/core/src/managers/ConfigManager';
import { ConfigurationTypes } from '../../../vendor_core/core/src/const/ConfigurationTypes';
import IDoubleChanceConfig from '../server/interface/IDoubleChanceConfig';
import CoinModel from '../../model/CoinModel';
import { getScatterBoostCost } from '../ui/commands/CRGameCommands';
import VendorModel from '../../../vendor_core/src/model/VendorModel';

export default class CRCSpinStartState extends VendorSpinStartMSTState {
    private freespinsLayer: Layer;
    private cancelFreeGamesButton: Button;

    public enter(): void {
        this.clearTumbleWin();
        super.enter()
    }

    protected onResponse(data?: any): void {
        super.onResponse(data);
        CoinModel.update(data);
        this.cancelFreeGamesButton?.setEnabled(!(SpinModel.hasFreespinsWon() || SpinModel.isInFreespins()));
    }

    hideWins(): void {
        ReelGroup.instance.winSymbolsView.unlockAll();
        ReelGroup.instance.winSymbolsView.stopAll();
    }
    private clearTumbleWin(): void {
        ViewManager.getLayer("ThumbleWinCounter").completeClear();
    }

    public updateFreeSpins(): void {
        this.freespinsLayer = ViewManager.getLayer( DefaultLayers.FreespinCounter );

        if (SpinModel.isInFreespins()) {
            this.freespinsLayer.setScene("open");
            const view = this.freespinsLayer.children[0] as PercentScalableSceneView;

            if (view) {
                const counter = view.sceneTextFields.get("fs_counter");
                counter ? counter.text = SpinModel.totalFreeSpins - SpinModel.freespinsNum + "/" + SpinModel.totalFreeSpins : null;
            }

        } else {
            this.freespinsLayer.clear();
        }
    }

    public startSpin(): void {
        CoinModel.clear();
        this.hideWins();
        this.updateFreeGames();
        this.updateFreeSpins();
        super.startSpin();
    }

    updateFreeGames(): void {
        // Free games check first, then free spins.
        const freegamesLayer = ViewManager.getLayer(DefaultLayers.FreegamesCounter);
        if(SpinModel.inFreegames()) {
            freegamesLayer.setScene("open");
            const freeGamesView = ViewManager.getLayer(DefaultLayers.FreegamesCounter).children[0] as PercentScalableSceneView;
            let counter = freeGamesView?.sceneTextFields.get("fg_counter");
            counter.text = (VendorModel.freeGames.spins -1) + "/" + (VendorModel.freeGames.spins + VendorModel.freeGames.spinsPlayed);
            this.cancelFreeGamesButton = freeGamesView.buttons.get("cancel_fg");
            let fg_cancelVisible = true;
            // imsFreespins is special for BET 365
            // https://docs.relax-gaming.com/partners/portal/operator-integrations#bet365
            if (VendorModel.freeGames.imsFreespins) {
                fg_cancelVisible = false;
            }
            this.cancelFreeGamesButton?.setVisible(fg_cancelVisible);

            // Will be disabled, while we wait for response from the server.
            this.cancelFreeGamesButton?.setEnabled(false);

        } else {
            freegamesLayer.clear();
        }
    }

    protected hasExtraPermission(): boolean {
        return BuyFeatureModel.hasBuyFeatureIsTriggered || BuyFeatureModel.isInBuyFeatureFreeSpins;
    }

    protected makeBet() {
        // if we have activated buy feature spin
        // substracted bet must be different
        const hasBuyFeatSpin = BuyFeatureModel.hasBuyFeatureIsTriggered || BuyFeatureModel.isInBuyFeatureFreeSpins;
        const hasDoubleChanceFeature = DoubleChanceModel.isActivated;
        const doubleChanceConfig = ConfigManager.getConfig<IDoubleChanceConfig>(ConfigurationTypes.GAME_SPECIFIC);
        BetModel.subtractBet(hasBuyFeatSpin
            ? BuyFeatureModel.getTotalBet()
            : hasDoubleChanceFeature
                ? getScatterBoostCost(BetModel.totalBet)
                : BetModel.totalBet);
        UIController.updateFields(UIUpdateEvent.Balance);
    }
}
